export default __webpack_public_path__ + "static/media/6.2a6d683b.png";